// extracted by mini-css-extract-plugin
export var wordContainer = "_rx-0";